import { LabelField } from 'components/LabelField';
import { SelectField } from 'components/SelectFields/SelectField';
import Selection from 'components/Selection/Selection';
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';



const VacationBox = ({
  usersData,
  eventUserLoading,
  setSelectedModule,
  selectedModule,
  isDisabled,
}) => {
  return (
    <>
      <div
        className="form-group mt-5"
        style={{
          textAlign: 'left',
        }}
      >
        <LabelField
          title={"Vacation Reassign (Optional)"}
          style={{
            fontSize: "12px",
          }}
          mandatory={false}
        />
        <Selection
          name="reassign"
          mandatory={false}
          placeholder="Select a vacation reassign"
          options={usersData}
          isLoading={eventUserLoading}
          style={"secondary"}
          onChange={(value) => {
            setSelectedModule((prev) => ({
              ...prev,
              pastoral: {
                ...prev?.pastoral,
                subModule: {
                  ...prev?.pastoral?.subModule,
                  vacation: {
                    ...prev?.pastoral?.subModule?.vacation,
                    description: value,
                  },
                }
              },
            }));
          }}
          value={selectedModule?.pastoral?.subModule?.vacation?.description}
          isClearable={true}
          isDisabled={isDisabled}
        />
      </div>
    </>
  )
}

export default VacationBox